var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports._updatePropsJS = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _JSReanimated = _interopRequireDefault(require("./JSReanimated"));
var _PlatformChecker = require("../PlatformChecker");
var createReactDOMStyle;
var createTransformValue;
var createTextShadowValue;
if ((0, _PlatformChecker.isWeb)()) {
    try {
        createReactDOMStyle = require("react-native-web/dist/exports/StyleSheet/compiler/createReactDOMStyle").default;
    } catch (e) {}
    try {
        createTransformValue = require("react-native-web/dist/exports/StyleSheet/preprocess").createTransformValue;
    } catch (e) {}
    try {
        createTextShadowValue = require("react-native-web/dist/exports/StyleSheet/preprocess").createTextShadowValue;
    } catch (e) {}
}
var reanimatedJS = new _JSReanimated.default();
global._makeShareableClone = function() {
    throw new Error("[Reanimated] _makeShareableClone should never be called in JSReanimated.");
};
global._scheduleOnJS = function() {
    throw new Error("[Reanimated] _scheduleOnJS should never be called in JSReanimated.");
};
var _updatePropsJS = exports._updatePropsJS = function _updatePropsJS(updates, viewRef, isAnimatedProps) {
    if (viewRef._component) {
        var component = viewRef._component;
        var _Object$keys$reduce = Object.keys(updates).reduce(function(acc, key) {
            var value = updates[key];
            var index = typeof value === "function" ? 1 : 0;
            acc[index][key] = value;
            return acc;
        }, [
            {},
            {}
        ]), _Object$keys$reduce2 = (0, _slicedToArray2.default)(_Object$keys$reduce, 1), rawStyles = _Object$keys$reduce2[0];
        if (typeof component.setNativeProps === "function") {
            setNativeProps(component, rawStyles, isAnimatedProps);
        } else if (createReactDOMStyle !== undefined && component.style !== undefined) {
            updatePropsDOM(component, rawStyles, isAnimatedProps);
        } else if (Object.keys(component.props).length > 0) {
            Object.keys(component.props).forEach(function(key) {
                if (!rawStyles[key]) {
                    return;
                }
                var dashedKey = key.replace(/[A-Z]/g, function(m) {
                    return "-" + m.toLowerCase();
                });
                component._touchableNode.setAttribute(dashedKey, rawStyles[key]);
            });
        } else {
            console.warn("It is not possible to manipulate component");
        }
    }
};
var setNativeProps = function setNativeProps(component, newProps, isAnimatedProps) {
    if (isAnimatedProps) {
        component.setNativeProps == null ? void 0 : component.setNativeProps(newProps);
        return;
    }
    var previousStyle = component.previousStyle ? component.previousStyle : {};
    var currentStyle = Object.assign({}, previousStyle, newProps);
    component.previousStyle = currentStyle;
    component.setNativeProps == null ? void 0 : component.setNativeProps({
        style: currentStyle
    });
};
var updatePropsDOM = function updatePropsDOM(component, style, isAnimatedProps) {
    var previousStyle = component.previousStyle ? component.previousStyle : {};
    var currentStyle = Object.assign({}, previousStyle, style);
    component.previousStyle = currentStyle;
    var domStyle = createReactDOMStyle(currentStyle);
    if (Array.isArray(domStyle.transform) && createTransformValue !== undefined) {
        domStyle.transform = createTransformValue(domStyle.transform);
    }
    if (createTextShadowValue !== undefined && (domStyle.textShadowColor || domStyle.textShadowRadius || domStyle.textShadowOffset)) {
        domStyle.textShadow = createTextShadowValue({
            textShadowColor: domStyle.textShadowColor,
            textShadowOffset: domStyle.textShadowOffset,
            textShadowRadius: domStyle.textShadowRadius
        });
    }
    for(var _key in domStyle){
        if (isAnimatedProps) {
            component.setAttribute(_key, domStyle[_key]);
        } else {
            component.style[_key] = domStyle[_key];
        }
    }
};
var _default = exports.default = reanimatedJS;
